export const PhotoCapture = {
  mounted() {
    const input = () => this.el.querySelector("input[type=file]")

    this.el.addEventListener("click", (event) => {
      const camera = event.target.closest("#booking-take-photo")
      const gallery = event.target.closest("#booking-choose-gallery")
      if (!camera && !gallery) return

      event.preventDefault()
      const file = input()
      if (!file) return

      if (camera) {
        file.setAttribute("capture", "environment")
      } else {
        file.removeAttribute("capture")
      }

      file.setAttribute("accept", "image/*")
      file.click()
    })
  },
}
